import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

// Définition de la mutation GraphQL
const UPDATE_COOPTATION = gql`
  mutation updateCooptations($uuidCoopting: ID!, $cooptedBy: [CooptationRequestDto]!) {
    updateCooptations(
      updatedCooptations: {
        consultantUuid: $uuidCoopting,
        cooptedBy: $cooptedBy
      }
    )
  }
`;

const useUpdateCooptation = () => {

    // Utilisation de la mutation Apollo
    const [updateCooptationMutation, { loading, error, data }] = useMutation(UPDATE_COOPTATION);

    const setCooptation = async (uuidCoopting, cooptedBy) => {

        // console.log("cooptedBy", cooptedBy);

        try {
            const response = await updateCooptationMutation({
                variables: {
                    uuidCoopting,
                    cooptedBy,
                },
            });

            // Vérifie si la mutation renvoie des erreurs
            if (!response || response.errors) {
                const errMessage = response?.errors?.[0]?.message || "Unknown error occurred";
                throw new Error(errMessage);
            }

            // console.log("debug response= ", response, "response.data = ", response.data)
            return { data: response.data, error: null };
        } catch (err) {
            console.error(err);
            return { data: false, error: err.message };
        }
    };
    // console.log("debug cooptations=", cooptations)

    return { setCooptation, loading, error };
};

export default useUpdateCooptation;
